import type {ReactNode} from "react";

interface ClientSubtitleProps {
    prefix: string;
    clientName: string | null;
    fallback: ReactNode;
}

export function ClientSubtitle({prefix, clientName, fallback}: ClientSubtitleProps) {
    if (!clientName) return <>{fallback}</>;
    return <>{prefix} {clientName}</>;
}
